export function formatDateTime(isoString) {
    const date = new Date(isoString);

    // Format day, month, year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();

    // Format hours, minutes, seconds
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Adjust for 12-hour format if needed
    const isPM = hours >= 12;
    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${String(hours).padStart(2, '0')}:${minutes} ${isPM ? 'PM' : 'AM'}`;

    return `${formattedDate} ${formattedTime}`;
}

export function formatDate(isoString) {
    const date = new Date(isoString);

    // Format day, month, year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const year = date.getFullYear();


    const formattedDate = `${day}/${month}/${year}`;

    return `${formattedDate}`;
}

export function formatDateMonth(isoString) {
    const date = new Date(isoString);
    const day = date.getDate();
    
    // Array of month names
    const months = [
        'january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december'
    ];
    
    // Get month name and convert first letter to uppercase
    const monthName = months[date.getMonth()].toLowerCase();
    
    return `${day} ${monthName}`;
}

export function formateDateFromMinus(minusSepratedDate) {
    if (!minusSepratedDate) return ""; // Return an empty string if no input is provided

    // Split the date string into day, month, and year
    const [day, month, year] = minusSepratedDate.split("-");

    // Rearrange into "yyyy-MM-dd" format
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function formateDateToMinus(date) {
    if (!date) return ""; // Return an empty string if no input is provided

    // Split the date string into year, month, and day
    const [year, month, day] = date.split("-");

    // Rearrange into "dd-MM-yyyy" format
    return `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${year}`;
}
